import { render, staticRenderFns } from "./simOpenWu.vue?vue&type=template&id=95f459ca&scoped=true&"
import script from "./simOpenWu.vue?vue&type=script&lang=js&"
export * from "./simOpenWu.vue?vue&type=script&lang=js&"
import style0 from "./simOpenWu.vue?vue&type=style&index=0&id=95f459ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f459ca",
  null
  
)

export default component.exports